import { useState, useMemo, useEffect } from 'react';

import type { PrinterInfo } from '@/bridge/print.bridge';

import { PrinterLocalService } from '@/bridge/PrinterLocalService';

export const usePrinter = () => {
  const [state, setState] = useState({
    isDiscovering: false,
    printerAvailable: false,
    printerIP: null as string | null,
    printers: [] as PrinterInfo[],
  });

  const printer = useMemo(() => PrinterLocalService.getInstance(), []);

  useEffect(() => {
    const updateState = () => {
      setState({
        isDiscovering: printer.isDiscovering,
        printerAvailable: printer.printerAvailable,
        printerIP: printer.ip || null,
        printers: printer.printers,
      });
    };

    updateState();

    const checkDiscovery = async () => {
      if (printer.discoveryPromise) {
        await printer.discoveryPromise;
        updateState();
      }
    };

    checkDiscovery();
  }, [printer]);

  return {
    ...state,
    testConnection: () => printer.testConnection(),
    printText: (text: string) => printer.printText(text),
    printPDF: (pdfBlob: Blob) => printer.printPDF(pdfBlob),
    printFromURL: (url: string) => printer.printFromURL(url),
    getPrinterStatus: () => printer.getPrinterStatus(),
    setSelectedPrinter: (ip: string) => {
      printer.setSelectedPrinter(ip);
      setState(prev => ({
        ...prev,
        printerIP: ip,
      }));
    },
  };
};
